import types from '@/store/types';
import { teamLeaderboard } from '@/api/teamLeaderboard';
import { store } from '@/store';
import toast from '@kk/toast';
import { throttle } from '@kk/utils';
import { globalData } from '@/global';

async function updateRank () {
  try {
    const { code, data, message } = await teamLeaderboard();

    if (code !== 200) {
      toast.show({
        text: message,
      });
    } else {
      if (data.myTeamRankInfo) {
        store.commit(types.SET_MY_TEAM_RANK, data.myTeamRankInfo);
      }
      store.commit(types.SET_TEAM_RANK, {
        list: data.teamRanks,
        host: data.host,
      });
      if (!store.state.randkDataReady) {
        store.commit(types.SET_RANK_DATA_READY);
      }
    }
  } catch (error) {
    const errMsg = (error as Error).message || '服务器错误';
    toast.show({
      text: errMsg,
    });
    console.log(error);
  }
}

const throttleUpdateRank = throttle(updateRank, 5000, true);

export function useUpdateTeamRank () {
  if (globalData.isKuaikan && store.state.user.uid) {
    throttleUpdateRank();
  } else {
    if (!store.state.randkDataReady) {
      store.commit(types.SET_RANK_DATA_READY);
    }
  }
}
